import mitt from 'mitt'

const emitter = mitt()

export const eventBus = {
  $on: (event, callback) => emitter.on(event, callback),
  $off: (event, callback) => emitter.off(event, callback),

  reloadReviewPoints: () => emitter.emit('reloadReviewPoints'),
  fetchingActionsStats: (state) => emitter.emit('fetchingActionsStats', state),
  fetchingAlertsStats: (state) => emitter.emit('fetchingAlertsStats', state),
  fetchingTop5AlertsStats: (state) => emitter.emit('fetchingTop5AlertsStats', state),
  fetchingVirtualTrainingStats: (state) => emitter.emit('fetchingVirtualTrainingStats', state),
  openDialog: (payload) => emitter.emit('openDialog', payload),
  fetchData: (payload, action, cleanDetails) => emitter.emit('fetchData', payload, action, cleanDetails),
  updateCreatorPermissions: (permission) => emitter.emit('updateCreatorPermissions', permission),
  updateOverallPermissions: (people, checked) => emitter.emit('updateOverallPermissions', people, checked),
  setLockProblemResolutionAnalysisView: (status) => emitter.emit('exitLocked', status),
  fetchTaskManagerGroups: (status) => emitter.emit('fetchTaskManagerGroups', status),
}

export default eventBus
